import React, { useState, useEffect, useContext } from "react";
// import "./Home.css";
import generator from "../../assets/generator.png";
import cash from "../../assets/cash.png";
import data from "../../assets/data.png";
import Navbar from "../../components/Navbar/Navbar";
import Form from "../../components/Form/Form";
import axios from "axios";
import Loader from "../../components/Loader/loader";
import Otp from "../../components/Otp/Otp";

import { sendOtpURL, confirmOtpURL } from "../../Utils/apis";
import Spinwheel from "../../components/Spinwheel/spinwheel";
import Wheel from "../../components/wheel";
import { notification } from "antd";
import { useHistory, Redirect } from "react-router-dom";
import { PlayContext } from "../../App";
import giftIcon from "../../images/gift-icon.png";



const Play = () => {
  const { open, toggleOpen } = useContext(PlayContext);
  const slideImages = [generator, data, cash];
  const [currentImg, setCurrentImg] = useState(generator);
  const history = useHistory();
  localStorage.getItem("token")
  localStorage.getItem("user")


  const { push } = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("authed");

    setInterval(() => {
      setCurrentImg(
        slideImages[Math.floor(Math.random() * slideImages.length)]
      );
    }, 5000);
  }, []);

  const [state, setState] = useState({
    authed: "notAuthenticated",
    // authed: false,
    msisdn: "",
    network: "",
    otp: "",
    wrongNum: false,
    showOtp: false,
    wrongOtp: false,
    isLoading: false,
    // imgArray: [
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "Generator",
    //   },
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "LOSE",
    //   },
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "200MB",
    //   },
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "LOSE",
    //   },
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "500MB",
    //   },
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "900MB",
    //   },
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "#500",
    //   },
    //   {
    //     prize_image: giftIcon,
    //     prize_text: "LOSE",
    //   },{
    //     prize_image: giftIcon,
    //     prize_text: "BICYCLE",
    //   },

    // ],
    imgArray: [
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
      {
        prize_image: giftIcon,
        prize_text: "???",
      },
    ],
  });

  const addToLocalStorage = (msisdn, network) => {
    localStorage.setItem("msisdn", msisdn);
    localStorage.setItem("network", network);
  };
  const isAuthenticated = (authed) => {
    const token = localStorage.getItem("authed");
    return token;
  };

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      showOtp: false,
    });
  };

  const onOTPChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const checkLength = () => {
    var long = document.getElementById("phoneNumber").value;
    var len = long.length;
    if (len !== 11) {
      setState({
        ...state,
        wrongNum: true,
      });
    } else {
      setState({
        ...state,
        wrongNum: false,
      });
    }
  };

  const openNotification = () => {
    const args = {
      message: "One-Time-Password",
      description: "Check your SMS. Input the sent OTP, OTP is valid For 24 hours.",
      duration: 10,
    };
    notification.open(args);
  };

  const openConfirmNotification = () => {
    const args = {
      message: "OTP validation successful",
      description: "You can Now Proceed to make a spin",
      duration: 10,
    };
    notification.open(args);
  };

  const openErrorNotification = () => {
    const args = {
      message: "Error",
      description: "An Error Occoured",
      duration: 10,
    };
    notification.open(args);
  };

  const openCustomErrorNotification = (msg) => {
    const args = {
      message: "Error",
      description: msg,
      duration: 10,
    };
    notification.open(args);
  };

  const sendOTP = () => {
    addToLocalStorage(msisdn, network);
    setState({
      ...state,
      isLoading: true,
    });
    axios({
      method: "post",
      url: sendOtpURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn,
        network,
      },
    })
      .then(function (result) {

        if (
          result.status === 200 &&
          result.data.status === "OtpDuplicationError"
        ) {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
          });
          openCustomErrorNotification(result.data.message);
        }
        if (result.status === 200 && result.data.status === "success") {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
          });
          openNotification();
        }
      })
      .catch((error) => {
        console.log(error);
        setState({
          ...state,
          isLoading: false,
        });
      });
  };

  const validateOTP = () => {
    isAuthenticated(true);
    setState({
      ...state,
      isLoading: true,
    });
    axios({
      method: "post",
      url: confirmOtpURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn,
        otp,
      },
    })
      .then(function (result) {
        if ((result.status = 200)) {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
            authed: "isAuthenticated",
          });
          toggleOpen();
          openConfirmNotification();
        }
      })
      .catch((error) => {
        console.log(error);
        openCustomErrorNotification("Invalid otp");
        setState({
          ...state,
          isLoading: false,
        });
      });
  };

  const { msisdn, network, otp, isLoading, wrongNum, showOtp, authed } = state;
  if (
    localStorage.getItem("authed") === "notAuthenticated" ||
    !localStorage.getItem("authed")
  ) {
    return <Redirect to="/" />;
  }
  return (
    <>
      <Navbar />
      <div className="row mt-3">
          <div className=" col-md-8 offset-2 text-center  ">
            <div className="" id="myCanvas">
              <Wheel items={state.imgArray} />
            </div>
          </div>
        </div>
    </>
  );
};

export default Play;
